"use strict";

(function () {
  'use strict';

  angular.module('lr.Flag').directive('lrFlag', ['$window', '$uibModal', function ($window, $uibModal) {
    return {
      restrict: 'E',
      scope: {
        property: '=',
        customText: '@',
        onChange: '&'
      },
      templateUrl: 'app/properties/flag/lr-flag-button.html',
      controllerAs: 'lrFlag',
      bindToController: true,
      controller: function lrFlag() {
        var vm = this;

        vm.flagProperty = function () {
          // $window.open('/work-orders/property/' + vm.property.pageDataID + '?status=flagged', '_blank');
          var modalInstance = $uibModal.open({
            templateUrl: 'app/properties/flag/lr-flag-modal.html',
            controller: 'FlagPropertyCTrl',
            resolve: {
              modalPropertyData: function modalPropertyData() {
                return vm.property;
              }
            }
          });
          modalInstance.result.then(function (result) {
            // console.log('result', result);
            if (result) {
              vm.onChange();
            }
          }, function () {
            console.log('cancelled');
          });
        };
      },
      link: function lrFlagLink(scope, element, attr) {}
    };
  }]).controller('FlagPropertyCTrl', ['$uibModalInstance', '$scope', 'User', 'modalPropertyData', 'PropertyFlagReason', 'StateFactory', 'PropertyFlagState', '$lrNotifier', function ($uibModalInstance, $scope, User, modalPropertyData, PropertyFlagReason, StateFactory, PropertyFlagState, $lrNotifier) {
    $scope.data = {};
    var State = StateFactory.State;
    $scope.property = modalPropertyData;
    $scope.reasonOptions = PropertyFlagReason;
    $scope.reason = PropertyFlagReason['Property Damaged'];
    var token = User.getToken();

    if (token) {
      $scope.data.reporter = token.UserName;
    }

    $scope.cancel = function () {
      $uibModalInstance.close();
    };

    var _geReasonNameFromReasonID = function _geReasonNameFromReasonID(value) {
      for (var prop in PropertyFlagReason) {
        if (PropertyFlagReason.hasOwnProperty(prop)) {
          if (PropertyFlagReason[prop] === value) return prop;
        }
      }
    }; // set the state of the property in the modal view


    var _setFlagState = function _setFlagState(action, isFlagged, stateID) {// $scope.property.state.FlagStateName = isFlagged ? 'Flagged' : 'Not Flagged';
      // $scope.property.state.FlagStateID = stateID;
      // $scope.property.state.FlagReasonName = _geReasonNameFromReasonID(stateID);
      // if (action === 'set') {
      //   $scope.property.state.FlagCount = $scope.property.state.FlagCount + 1;
      // } else if (action === 'resolve') {
      //   $scope.property.state.FlagCount = 0;
      // }
    };

    $scope.submitFlag = function () {
      State.flagProperty($scope.property, PropertyFlagState.flagged, $scope.reason).then(function () {
        _setFlagState('set', PropertyFlagState.flagged, $scope.reason);

        $uibModalInstance.close(true);
        $lrNotifier.content('Property Flagged').show();
      });
    };

    $scope.resolveFlag = function () {
      State.flagProperty($scope.property, PropertyFlagState.notFlagged, 0).then(function () {
        _setFlagState('resolve', PropertyFlagState.notFlagged, 0);

        $uibModalInstance.close(true);
        $lrNotifier.content('Flag Resolved').show();
      });
    };

    $scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened = true;
    };
  }]);
})();